// components/SearchBar.js

import { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import DatePicker from "react-datepicker";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import SearchIcon from "@material-ui/icons/Search";

import {
    clearOptional, 
    getBankAccount, 
    getBankAccounts, 
    getStringDatesFilter, 
    setEndDate, 
    setStartDate, 
    setMyBankAccount, 
    updateDate,
    getOptional,
    setOptional
} from "../app/filters";
import calendarIcon from "../assets/img/calendar.png";
import FilterButton from "../components/FilterButton";
import { formatDate } from "../utils/dateFuncs";

const SearchBar = ({ target }) => {
    const [showButtonsDate, setShowButtonsDate] = useState(true);

    const [startDate, endDate] = useSelector(getStringDatesFilter(target));
    const [dateRange, setDateRange] = useState({ start: startDate, end: endDate });

    useEffect(() => {
        setDateRange({ start: startDate, end: endDate });
    }, [startDate, endDate]);

    const startDatePickerRef = useRef(null);
    const endDatePickerRef = useRef(null);

    const dispatch = useDispatch();

    const { searchTerms, minAmount, maxAmount } = useSelector((state) => getOptional(state, target));
    const [optionalFilters, setOptionalFilters] = useState({ searchTerms, minAmount, maxAmount });

    useEffect(() => {
        setOptionalFilters({ searchTerms, minAmount, maxAmount });
    }, [searchTerms, minAmount, maxAmount]);

    const updateFilters = (values) => {
        setOptionalFilters((prev) => ({ ...prev, ...values }));
    }

    const handleIconClick = (pickerRef) => {
        if (pickerRef.current) {
            pickerRef.current.setOpen(true);
        }
    }

    const filter = () => {
        if (showButtonsDate) {
            const startDateElement = document.getElementById("input-period-from");
            const endDateElement = document.getElementById("input-period-to");
    
            const startDateValidity = startDateElement.validity.valid;
            const endDateValidity = endDateElement.validity.valid;

            dispatch(setStartDate({ target, value: formatDate(dateRange.start), validity: startDateValidity }));
            dispatch(setEndDate({ target, value: formatDate(dateRange.end), validity: endDateValidity }));
        }

        dispatch(setOptional({ target, values: optionalFilters }));
    }

    return (
        <div>
            <div className="rounded-xl flex relative border border-[#EEEEEE] h-[2.3rem] sidebar:h-[2.7rem] items-center text-xs sidebar:text-base sidebar:py-1">
                <input 
                    type="text" 
                    name="search" 
                    placeholder="Recherche..." 
                    className="w-5/6 rounded-xl pl-[1rem]" 
                    value={optionalFilters.searchTerms} 
                    onChange={(e) => updateFilters({ ...optionalFilters, searchTerms: e.target.value })}
                />
                <SearchIcon/>
            </div>
            <div className="w-full flex pt-[1.2rem]">
                <div className="w-1/2 mr-2 rounded-xl flex h-[2.3rem] relative border border-[#EEEEEE] sidebar:py-0.5 items-center">
                    <input 
                        type="number" 
                        name="min" 
                        placeholder="Min TTC" 
                        className="w-full px-4 py-1 rounded-xl text-xs sidebar:text-base" 
                        value={optionalFilters.minAmount}
                        onChange={(e) => updateFilters({ ...optionalFilters, minAmount: e.target.value })} 
                    />
                </div>
                <div className="w-1/2 ml-2 rounded-xl flex h-[2.3rem] relative border border-[#EEEEEE] sidebar:py-0.5  items-center">
                    <input 
                        type="number" 
                        name="max" 
                        placeholder="Max TTC" 
                        className="w-full px-4 py-1 rounded-xl text-xs sidebar:text-base" 
                        value={optionalFilters.maxAmount}
                        onChange={(e) => updateFilters({ ...optionalFilters, maxAmount: e.target.value })}
                    />
                </div>
            </div>
            <div className="w-[9.3rem] sidebar:w-[17.5rem] text-[14px] sidebar:text-base sidebar:normal rounded-r-xl sidebar:mt-2 pick-input">
                <p className="hidden sidebar:block text-black font-bold text-base">Menu</p>
                <div className="w-full flex items-center sidebar:items-center sidebar:mt-[1.2rem] h-[2rem]">
                    <img 
                        className="w-[25px] sidebar:w-[30px]" 
                        src={calendarIcon} 
                        onClick={() => showButtonsDate ? setShowButtonsDate(false) : setShowButtonsDate(true)} 
                        alt="calendar" 
                    />
                    <h2 className="pl-[0.9rem] sidebar:text-base font-semibold">Période affichée</h2>
                </div>
			
                {showButtonsDate ?
                    <div className="flex justify-between w-[9.3rem] sidebar:w-[17.5rem] mt-[1.5rem] sidebar:mt-[0.9rem] periode-aff">
                        <div className="px-[0.9rem] flex justify-center w-[48%] rounded-lg border h-[2.3rem] sidebar:py-1 sidebar:h-[2.7rem] items-center">
                            <div className="flex text-xs items-center dates-filtre font-bold relative w-full">
                                <span className="uppercase mr-1">Du</span>
                                <DatePicker
                                    id="input-period-from"
                                    selected={dateRange.start}
                                    showMonthDropdown
                                    showYearDropdown
                                    onChange={(date) => setDateRange({ ...dateRange, start: date })}
                                    className="bg-none-input custom-calendar text-xs w-full pr-[0.5rem]" 
                                    dateFormat="dd/MM/yyyy"
                                    minDate={new Date('1990-01-01')}
                                    maxDate={new Date('2300-01-01')}
                                    ref={startDatePickerRef}
                                />
                                <ArrowDropDownIcon
                                    className="custom-calendar-icon absolute right-0 top-1/2 transform -translate-y-1/2 cursor-pointer text-gray-500"
                                    onClick={() => handleIconClick(startDatePickerRef)}
                                />
                            </div>
                        </div>
                        <div className="px-[0.9rem] flex justify-center w-[48%] mt-[1.2rem] sidebar:mt-0 rounded-lg border h-[2.3rem] sidebar:py-1 sidebar:h-[2.7rem] items-center">
                            <div className="flex text-xs items-center dates-filtre font-bold relative w-full">
                                <span className="uppercase mr-1">Au</span>
                                <DatePicker
                                    id="input-period-to"
                                    selected={dateRange.end}
                                    showMonthDropdown
                                    showYearDropdown
                                    onChange={(date) => setDateRange({ ...dateRange, end: date })}
                                    className="bg-none-input custom-calendar text-xs w-full pr-[0.5rem]"
                                    dateFormat="dd/MM/yyyy"
                                    minDate={new Date('1990-01-01')}
                                    maxDate={new Date('2300-12-31')}
                                    ref={endDatePickerRef}
                                />
                                <ArrowDropDownIcon
                                    className="custom-calendar-icon absolute right-0 top-1/2 transform -translate-y-1/2 cursor-pointer text-gray-500"
                                    onClick={() => handleIconClick(endDatePickerRef)}
                                />
                            </div>
                        </div>
                    </div>
                :
                    <form className="rounded-r-xl mt-[0.9rem] w-full flex relative input-field">
                        <input type="month" name="periodeaffiche"/>
                        <ArrowDropDownIcon size="small" className="pointer-events-none"/>
                    </form>
                }
                <FilterButton target={target} filter={filter} />
            </div>
        </div>
    )
}

export default SearchBar;
